module.exports = __webpack_public_path__ + "img/thumbnail_EuropeanBadger_m_erythristic.bdfbce52.png";